export default __webpack_public_path__ + "static/media/icon_triangle.6e2ff063.svg";